module.exports = __webpack_public_path__ + "img/i_videos.731e6e09.svg";